import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@snack-uikit/typography';
import { SIZE } from '../../constants';
export function CrumbsTypography({ size, children, className }) {
    return (_jsx(Typography, { className: className, size: size === SIZE.S ? 'm' : 's', tag: 'div', family: 'sans', purpose: 'body', children: children }));
}
